

import CheckpointClient, { CheckpointError, CHECKPOINT_APPS, CheckpointAppName } from '../../checkpoint';

function detectTokenStorage(): 'localStorage' | 'sessionStorage' {
    try {
        if (window.localStorage.getItem('checkpoint_access_token')) {
            return 'localStorage';
        }
        if (window.sessionStorage.getItem('checkpoint_access_token')) {
            return 'sessionStorage';
        }
    } catch {
        // Ignore storage access errors
    }

    return 'localStorage';
}

// console.log(process.env);

// # Vite client-side variables (exposed to browser)
// VITE_CHECKPOINT_BASE_URL="${CHECKPOINT_BASE_URL}"
// VITE_CHECKPOINT_SSO_DOMAIN="${CHECKPOINT_SSO_DOMAIN}"
// VITE_CHECKPOINT_APP_ID="${CHECKPOINT_APP_ID}"
// VITE_CHECKPOINT_SERVER_URL="${CHECKPOINT_SERVER_URL}"

export function initializeCheckpointClient(appName: CheckpointAppName): CheckpointClient {
    const storageType = detectTokenStorage();
    // Vite exposes client globals via import.meta.env. They must be prefixed with VITE_ in .env files.
    const appId = import.meta.env.VITE_CHECKPOINT_APP_ID || '';
    const serverURL = import.meta.env.VITE_CHECKPOINT_SERVER_URL || '';
    const baseUrl = import.meta.env.VITE_CHECKPOINT_BASE_URL || '';
    const ssoDomain = import.meta.env.VITE_CHECKPOINT_SSO_DOMAIN || window.location.origin;

    // console.log(appId);
    // console.log(serverURL);
    // console.log(baseUrl);
    // console.log(ssoDomain);
    let checkpoint = new CheckpointClient({
        appId,
        serverURL,
        baseUrl,
        ssoDomain,
        appName: appName,
        storage: storageType,
        autoRefresh: true,  
    });
    return checkpoint;
}

export let checkpointObjects = {
    ssoDomain: import.meta.env.VITE_CHECKPOINT_SSO_DOMAIN,
    baseUrl: import.meta.env.VITE_CHECKPOINT_BASE_URL,
    serverURL: import.meta.env.VITE_CHECKPOINT_SERVER_URL,
    appId: import.meta.env.VITE_CHECKPOINT_APP_ID,
}

